import React from 'react'
import styled from 'styled-components'

const SettingsElement = ({ icon, text, onClick, reverse, customColor, selected }) => {
  return (
    <SettingsElementContainer
      onClick={onClick}
      reverse={reverse}
      customColor={customColor}
      selected={selected}
    >
      {icon} <ElementText customColor={customColor} selected={selected}>{text}</ElementText>
    </SettingsElementContainer>
  )
}

export default SettingsElement
const SettingsElementContainer = styled.div`
display:flex;
width100%;
align-items:center;
padding:16px;
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:12px;
cursor:pointer;
 color:${({ selected, theme, customColor }) => selected ? (theme.menu.selectedTextColor) : (customColor ? customColor : theme.menu.secondaryTextColor)};
background:${({ selected, theme }) => selected ? (theme.menu.selectedOpionBackground) : ""};
  &:last-child {
    border: none;
  }

svg{
max-height:20px;
max-width:20px;
}

${(props) => props.reverse &&
    `
  flex-direction:row-reverse;
justify-content:space-between;
  `}

`

const ElementText = styled.p`
font-family: Inter;
font-weight: 500;
font-size: 16px;
line-height: 22px;
letter-spacing: -0.41px;
 color:${({ selected, theme, customColor }) => selected ? (theme.menu.selectedTextColor) : (customColor ? customColor : theme.menu.secondaryTextColor)};
`